import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { auctionsParamsSchema } from 'src/pages/transport/auctions/tiles/schema';

export function useAuctionsPageParams() {
  return usePageParamsFromSchema(auctionsParamsSchema);
}

export type AuctionsPageParams = ReturnType<typeof useAuctionsPageParams>;
